import reduxCrud from 'redux-crud';

const customFieldsActionCreators = reduxCrud.actionCreatorsFor('customFields', {
  key: 'id',
});
const actionTypes = reduxCrud.actionTypesFor('customFields', { key: 'id' });

export default customFieldsActionCreators;
export { actionTypes };
